import { render, staticRenderFns } from "./PersonSingleRate.vue?vue&type=template&id=20843fb8&scoped=true"
import script from "./PersonSingleRate.vue?vue&type=script&lang=js"
export * from "./PersonSingleRate.vue?vue&type=script&lang=js"
import style0 from "./PersonSingleRate.vue?vue&type=style&index=0&id=20843fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20843fb8",
  null
  
)

export default component.exports